<template>
  <div class="main-content">

    <SideBarModal
      v-if="userEditId"
      :user="{id:userEditId}"
      :roles="roles"
      :updateRecord="updateUserList"
      :onModalClose="() => this.userEditId = null"
    />

    <template v-if="loading">
      <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
    </template>
    <template v-else>
      <div class="card mb-1" v-for="div in $AllDivisions">
        <div class="card-header bg-info">
          <h6>
            <strong><span v-for="(c, i) in div.cities">{{ c.city && c.city.name || 'Почта' }}{{ i === 0 && div.cities.length > 1 ? ', ' : '' }}</span></strong>
            (ID:{{ div.id }})
          </h6>
        </div>
        <div class="card-body p-3">
          <table class="table table-striped table-sm table-hover mb-0">
            <tbody>
            <template v-if="users[div.id] && users[div.id].chief">
              <tr class="label">
                <td width="380px">Главные курьеры:</td>
                <td width="150px"></td>
                <td width="30%"></td>
                <td colspan="20"></td>
              </tr>
              <tr v-for="r in users[div.id].chief">
                <td>{{ r.name }} ({{ r.login }})</td>
                <td>
                  <template v-if="userDetails[r.id].tablet_imei">

                    <button
                      v-if="!popover[r.id].imei"
                      type="button"
                      @click="popover[r.id].imei = true"
                      class="btn btn-xs btn-outline-info"
                    >
                      {{ userDetails[r.id].tablet_imei.details }}
                    </button>

                    <v-popover
                      popoverClass="popover_white"
                      :auto-hide="true"
                      @hide="destroyPopover(r.id, 'imei')"
                      :open="popover[r.id] && popover[r.id].imei"
                      v-if="popover[r.id].imei"
                    >
                      <button type="button" class="btn btn-xs btn-outline-info">
                        {{ userDetails[r.id].tablet_imei.details }}
                      </button>
                      <template slot="popover">
                        <div>
                          <p class="mb-1">Редактирование устройства</p>
                          <div>
                            <LoadingButton
                              title="Отвязать IMEI"
                              className="btn btn-warning btn-xs mb-1"
                              :onClick="() => updateUser(r.id, 'imei', 'disable_imei')"
                              :loading="btnLoading"
                              color="white"
                            />

                            <LoadingButton
                              title="Отозвать сертификат"
                              className="btn btn-warning btn-xs"
                              :onClick="() => updateUser(r.id, 'imei', 'disable_tablet_certificate')"
                              :loading="btnLoading"
                              color="white"
                            />
                          </div>
                        </div>
                      </template>
                    </v-popover>

                  </template>
                </td>
                <td>
                  <div v-html="userInfoMessage(r.id)"/>
                </td>
                <td colspan="20" class="text-right">
                  <div>
                    <button
                      v-if="users[div.id].runners && users[div.id].runners.length"
                      class="btn btn-default btn-xs mr-1"
                      @click="showRunners[div.id] = !showRunners[div.id]"
                    >
                      Курьеры в группе ({{ users[div.id].runners.length }})
                    </button>
                    <button
                      @click="openUserInModal(r.id)"
                      class="btn btn-xs btn-info mr-1"
                    >
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                    <button
                      @click="
                    mixinGoToRouter('settingsAccessUsersEdit', {
                      id:r.id
                    })
                  "
                      class="btn btn-info btn-xs hidden"
                    >
                      <i class="icon-fa icon-fa-edit"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="warning">
                <td colspan="20">Главный курьер не назначен!</td>
              </tr>
            </template>
            <template v-if="users[div.id] && users[div.id].runners && showRunners[div.id]">
              <tr class="label">
                <td width="380px">Курьеры</td>
                <td width="150px">IMEI</td>
                <td width="30%">Info</td>
                <td></td>
              </tr>
              <tr v-for="r in users[div.id].runners">
                <td>
                  {{ r.name }} ({{ r.login }})
                </td>
                <td>
                  <template v-if="userDetails[r.id].tablet_imei">
                    <button
                      v-if="!popover[r.id].imei"
                      type="button"
                      @click="popover[r.id].imei = true"
                      class="btn btn-xs btn-outline-info"
                    >
                      {{ userDetails[r.id].tablet_imei.details }}
                    </button>

                    <v-popover
                      popoverClass="popover_white"
                      :auto-hide="true"
                      @hide="destroyPopover(r.id, 'imei')"
                      :open="popover[r.id] && popover[r.id].imei"
                      v-if="popover[r.id].imei"
                    >
                      <button type="button" class="btn btn-xs btn-outline-info">
                        {{ userDetails[r.id].tablet_imei.details }}
                      </button>
                      <template slot="popover">
                        <div>
                          <p class="mb-1">Редактирование устройства</p>
                          <div>
                            <LoadingButton
                              title="Отвязать IMEI"
                              className="btn btn-warning btn-xs mb-1"
                              :onClick="() => updateUser(r.id, 'imei', 'disable_imei')"
                              :loading="btnLoading"
                              color="white"
                            />
                            <LoadingButton
                              title="Отозвать сертификат"
                              className="btn btn-warning btn-xs"
                              :onClick="() => updateUser(r.id, 'imei', 'disable_tablet_certificate')"
                              :loading="btnLoading"
                              color="white"
                            />
                          </div>
                        </div>
                      </template>
                    </v-popover>
                  </template>
                </td>
                <td>
                  <div v-html="userInfoMessage(r.id)"/>
                </td>
                <td class="text-right">
                  <div class="flex justify-content-end">
                    <button
                      v-if="!popover[r.id].disable && (!r.orders || !r.orders.length)"
                      type="button"
                      @click="popover[r.id].disable = true"
                      class="btn btn-xs btn-outline-warning mr-1"
                    >
                      В архив
                    </button>

                    <v-popover
                      popoverClass="popover_white"
                      :auto-hide="true"
                      @hide="destroyPopover(r.id, 'disable')"
                      :open="popover[r.id] && popover[r.id].disable"
                      v-if="popover[r.id].disable"
                    >
                      <button type="button" class="btn btn-xs btn-outline-warning mr-1">
                        В архив
                      </button>
                      <template slot="popover">
                        <div>
                          <p class="mb-1">Отправить курьера</p>
                          <p class="mb-1"><strong>{{ r.name }}</strong></p>
                          <p class="mb-1">в архив?</p>
                          <div>
                            <LoadingButton
                              title="в архив"
                              className="btn btn-warning btn-xs"
                              :onClick="() => updateUser(r.id, 'disable')"
                              :loading="btnLoading"
                              color="white"
                            />
                          </div>
                        </div>
                      </template>
                    </v-popover>

                    <button
                      @click="openUserInModal(r.id)"
                      class="btn btn-xs btn-info mr-1"
                    >
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                    <button
                      @click="
                    mixinGoToRouter('settingsAccessUsersEdit', {
                      id:u.id
                    })
                  "
                      class="btn btn-info btn-xs hidden"
                    >
                      <i class="icon-fa icon-fa-edit"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="unlinkedUsers && unlinkedUsers.length > 0" class="card">
        <div class="card-header">
          <h6>Курьеры без дивизиона</h6>
        </div>
        <div class="card-body">
          <table class="table table-hover table-sm table-striped">
            <tbody>
            <tr v-for="(u, i) in unlinkedUsers">
              <td>{{ i + 1 }}</td>
              <td>{{ u.name }}</td>
              <td class="text-right">
                <div class="">
                  <button
                    @click="openUserInModal(u.id)"
                    class="btn btn-xs btn-info mr-1"
                  >
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                  <button
                    @click="
                    mixinGoToRouter('settingsAccessUsersEdit', {
                      id:u.id
                    })
                  "
                    class="btn btn-info btn-xs hidden"
                  >
                    <i class="icon-fa icon-fa-edit"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="inactiveUsers && inactiveUsers.length > 0" class="card">
        <div class="card-header bg-warning">
          <h6>Не активные курьеры</h6>
        </div>
        <div class="card-body">
          <table class="table table-hover table-sm table-striped">
            <tbody>
            <tr v-for="(u, i) in inactiveUsers">
              <td>{{ i + 1 }}</td>
              <td>{{ u.name }}</td>
              <td class="text-right">
                <div class="">
                  <button
                    @click="openUserInModal(u.id)"
                    class="btn btn-xs btn-info mr-1"
                  >
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                  <button
                    @click="
                    mixinGoToRouter('settingsAccessUsersEdit', {
                      id:u.id
                    })
                  "
                    class="btn btn-info btn-xs hidden"
                  >
                    <i class="icon-fa icon-fa-edit"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </template>
  </div>
</template>

<script>

import api from "@/api";
import SideBarModal from "@/components/modals/users/SideBarModal"
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    SideBarModal,
    LoadingButton,
  },
  data() {
    return {
      btnLoading: false,
      popover: {},
      showRunners: {},
      roles: [],
      userEditId: null,
      users: {},
      userDetails: {},
      unlinkedUsers: [],
      inactiveUsers: [],
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
    }
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    }
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    userInfoMessage(id) {
      let html = '';
      if (!this.userDetails[id].images) {
        html += '<p class="color_dark_red mb-0">Нет сканов документов!</p>';
      }
      return html;
    },
    async updateUser(id, action, subAction = null) {
      this.btnLoading = true;
      console.log(action);
      const {data} = await api.post('users/edit/' + id, {
        user: {id: id},
        action,
        subAction
      })
      if (data.success) {
        toastr['success']('Обновлено');
        this.destroyPopover(id, action);
        switch (action) {
          case 'disable':
            let division;
            let index;
            Object.keys(this.users).forEach((div) => {
              if (!this.users[div].runners) return;
              if (index && index !== -1) return;
              index = this.users[div].runners.findIndex((u) => u.id === id);
              if (index && index !== -1) {
                division = div;
              }
            })
            let allRunners = [...this.users[division].runners];
            let runner = this.users[division].runners[index];
            delete allRunners[index];
            allRunners = allRunners.filter((r) => r);
            this.users[division].runners = allRunners;
            this.inactiveUsers.push(runner);
            break;
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    destroyPopover(id, type) {
      this.popover[id][type] = false;
    },
    updateUserList(user = null) {
      console.log(user);
      console.log('update 2');
      this.getUsers();
    },
    openUserInModal(id) {
      this.userEditId = id;
    },
    getDetailByAlias(userId, alias, value = true) {
      let userIndex = -1;
      let division = null;
      Object.keys(this.users).forEach((div) => {
        if (userIndex !== -1) return;
        if (!this.users[div].runners) return;
        userIndex = this.users[div].runners.findIndex((u) => u.id === userId);
        if (userIndex !== -1) {
          division = div;
        }
      })
      if (userIndex === -1) return;
      const detailIndex = this.users[division].runners[userIndex].details.findIndex((d) => d.alias === alias);
      if (value) {
        return this.users[division].runners[userIndex].details[detailIndex] && this.users[division].runners[userIndex].details[detailIndex].details;
      } else {
        return this.users[division].runners[userIndex].details[detailIndex];
      }
    },
    async getUsers() {
      this.loading = true;
      const {data} = await api.index('/users/runners');
      if (data.success) {
        this.roles = data.roles;
        this.unlinkedUsers = data.unlinkedUsers;
        this.inactiveUsers = data.inactiveUsers;
        let userDetails = {};
        let popover = {};
        Object.keys(data.users).forEach((div) => {
          this.showRunners[div] = false;
          // if (!data.users[div].runners) return;
          ([...(data.users[div].runners || []), ...(data.users[div].chief || [])]).forEach((u) => {
            userDetails[u.id] = {};
            popover[u.id] = {
              disable: false,
              imei: false,
            };
            u.details.forEach((d) => {
              userDetails[u.id][d.alias] = d;
            })
          });
        })
        this.popover = popover;
        this.showRunners = {...this.showRunners};
        this.userDetails = userDetails;
        this.users = data.users;
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
tr.label {
  font-weight: 600;
}

tr.warning {
  background-color: #ffe3e3 !important;
  font-weight: 600;
}
</style>
